.vault {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 600px;
  margin-left: auto;
  margin-right: auto;

  .box {
    height: 320px;
    border-radius: 10px;
    border: 1px solid #e9ecef;
    display: flex;
    flex-direction: column;
    background-color: #fff;

    padding: 40px;
  }
}

.language {
  position: absolute;
  left: 20px;
  top: 20px;
}
